// extracted by mini-css-extract-plugin
module.exports = {"modalbody":"CustomModal_modalbody__3r0U2","close-btn":"CustomModal_close-btn__1prRR"};